<template>
  <v-main class="main-pane">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="10"
      :search="search"
      v-model="selected"
      show-select
      :footer-props="footer_props"
      :no-data-text="$t('label.nodata')"
      item-key="pos"
      class="elevation-1 table-fluid idcs-pane-back px-4"
      :sort-by="'dt'"
      :sort-desc="false"
    >
      <template v-slot:progress>
        <div class="progress-container">
          <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
        </div>
      </template>
      <template v-slot:top>
        <v-row class="ml-0" align="center">
          <v-col cols="12" md="4">
            <v-btn v-if="selected.length" icon @click="printSelected">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <date-picker
              v-model="sd"
              range
              confirm
              clearable
              @confirm="newRange"
              :shortcuts="shortcuts"
              :lang="$i18n.locale"
              :input-class="'idcs-data-pick'"
              class="idcs-picker-wrap"
            ></date-picker>
          </v-col>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="filter.subcompany"
              :items="subcompanies"
              clearable
              :label="$t('field.subcompany')"
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <!-- <v-selecttext-field v-model="filter.terminal" clearable :label="$t('field.terminal')"></v-selecttext-field> -->
            <v-select
              v-model="filter.terminal"
              :items="terminals"
              clearable
              :label="$t('field.terminal')"
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filter.zrep" clearable :items="zrepfilter"></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.DT="{item}">{{item.DT | dt-time}}</template>
      <template v-slot:item.plus="{item}">{{item.plus | currency}}</template>
      <template v-slot:item.minus="{item}">{{item.minus | currency}}</template>
      <template v-slot:item.actions="{item}">
        <v-btn icon @click.prevent="showData(item.resp_par1)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template
        v-slot:item.req_par1="{item}"
      >{{item.req_par1=="1"?$t("field.cmd900z"):$t("field.cmd900x")}}</template>
      <template v-slot:body.append="{headers}">
        <tr>
          <td :colspan="headers.length-3" class="detail-row">
            <v-subheader>{{$t('label.modified')+': '+ lastUpdate.format("H:mm:ss")}}</v-subheader>
          </td>
          <td class="detail-row" align="right">{{totalplus|currency}}</td>
          <td class="detail-row" align="right">{{totalminus|currency}}</td>
          <td class="detail-row" align="center">{{totalcount}}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showDataDialog" persistent transition="scroll-y-transition" width="510px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="showDataDialog=false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div id="topdf" v-html="dataDialogMessage" class="dialog-content"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
//import axios from "axios";
//import { jsPDF } from "jspdf";
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/lv.js";
import "vue2-datepicker/locale/ru.js";
import commonTables from "@/mixins/tables_common.js";

export default {
  mixins: [commonTables],
  components: { DatePicker },
  name: "PosReports",
  data() {
    return {
      d_print: false,
      showDataDialog: false,
      dataDialogMessage: "",
      search: null,
      selected: [],
      sd: [new Date(), new Date()],
      lastUpdate: this.$moment(),
      loading: false,
      allTotal: {
        plus: 0,
        minus: 0,
        count: 0,
      },
      selectedTotal: {
        plus: 0,
        minus: 0,
        count: 0,
      },
      zrepfilter: [
        {
          text: this.$t("field.cmd900x"),
          value: 2,
        },
        {
          text: this.$t("field.cmd900z"),
          value: 1,
        },
      ],
      items: [],
      filter: {
        subcompany: null,
        terminal: null,
        zrep: 1,
      },
      terminals: [],
      subcompanies: [],
      headers: [
        {
          text: "",
          align: "center",
          value: "actions",
          sortable: false,
          size: 70,
        },
        {
          text: "#",
          align: "center",
          value: "nr",
          sortable: true,
        },
        {
          text: this.$t("field.dt"),
          align: "left",
          value: "dt",
          sortable: true,
        },
        // {
        //   text: this.$t("field.company"),
        //   value: "company",
        //   sortable: true,
        // },
        {
          text: this.$t("field.subcompany"),
          value: "subcompany",
          filter: (value) => {
            return (
              !this.filter.subcompany ||
              value
                .toLowerCase()
                .indexOf(this.filter.subcompany.toLowerCase()) != -1
            );
          },
          sortable: true,
        },
        {
          text: this.$t("field.req_terminal"),
          value: "req_terminal",
          filter: (value) => {
            return (
              !this.filter.terminal ||
              value.toLowerCase().indexOf(this.filter.terminal.toLowerCase()) !=
                -1
            );
          },
          sortable: true,
        },
        {
          text: this.$t("field.par1"),
          align: "center",
          value: "req_par1",
          filter: (value) => {
            return !this.filter.zrep || value == this.filter.zrep;
          },
          sortable: true,
        },
        {
          text: "",
          align: "right",
          value: "plus",
        },
        {
          text: "",
          align: "right",
          value: "minus",
        },
        {
          text: "",
          align: "center",
          value: "count",
        },
      ],
    };
  },
  watch: {
    sd: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    selected() {
      this.selectedTotal = {
        plus: 0,
        minus: 0,
        count: 0,
      };
      this.selected.forEach((e) => {
        this.selectedTotal.plus += isNaN(e.plus) ? 0 : parseInt(e.plus);
        this.selectedTotal.minus += isNaN(e.minus) ? 0 : parseInt(e.minus);
        this.selectedTotal.count += isNaN(e.count) ? 0 : parseInt(e.count);
      });
    },
  },
  computed: {
    totalplus() {
      try {
        if (this.selected.length) return this.selectedTotal.plus;
        return this.allTotal.plus;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    totalminus() {
      try {
        if (this.selected.length) return this.selectedTotal.minus;
        return this.allTotal.minus;
      } catch (error) {
        return 0;
      }
    },
    totalcount() {
      try {
        if (this.selected.length) return this.selectedTotal.count;
        return this.allTotal.count;
      } catch (error) {
        return 0;
      }
    },
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    printSelected() {
      var printWindow = window.open("_blank");
      printWindow.document.write(
        "<html><head><title>" + this.$t("menu.posreports") + "</title>"
      );
      printWindow.document.write(
        "<style type='text/css'> .pbb {  page-break-before: always;}</style>"
      );
      let body = "";
      printWindow.document.write("</head><body>");
      const MAXROW = 3;
      const MAXTABLE = 12;
      this.selected.forEach((e, i) => {
        if (i % MAXTABLE == 0) {
          body += "<table>";
        }

        if (i % MAXROW == 0) {
          body += "<tr>";
        }
        body += "<td" + (i > 2 ? " style='padding-top:40px;'" : "") + ">";
        body +=
          "<div style='width: 300px;text-align: center;white-space: pre;font-size: 11px;font-family: monospace;'>";
        body += e.div; //this.parse(e.resp_par1);
        body += "</div>";
        body += "</td>";
        if ((i + 1) % MAXROW == 0) {
          body += "</tr>";
        }
        if ((i + 1) % MAXTABLE == 0) {
          body += "</table>";
          //console.log(i, this.selected.length, "pbb");
          if (i + 1 != this.selected.length) body += "<p class=pbb>break</p>";
        }
        //      console.log(i, table, row, "end");
      });
      //      console.log(this.selected.length, this.selected.length % MAXROW != 0);
      if (this.selected.length % MAXROW != 0) {
        body += "</tr></table>";
      }
      printWindow.document.write(body);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
    },
    parse(d) {
      let m = "";
      while (d.length > 0) {
        m += "<p>" + d.substring(0, 42) + "</p>";
        d = d.substring(42);
      }
      return m;
    },
    showData(d) {
      this.dataDialogMessage = this.parse(d);
      this.showDataDialog = true;
    },
    getDataFromApi() {
      this.items.splice(0);
      this.selected.splice(0);

      this.loading = true;
      const params = {};
      if (this.sd[0] == null) this.sd[0] = new Date();
      if (this.sd[1] == null) this.sd[1] = new Date();
      params.sd = this.$moment(this.sd[0]).format("YYYYMMDD");
      params.ed = this.$moment(this.sd[1]).format("YYYYMMDD");
      app.loadPosReports(params).then((response) => {
        this.items = response.items;
        this.allTotal = {
          plus: 0,
          minus: 0,
          count: 0,
        };
        this.terminals.splice(0);
        this.subcompanies.splice(0);
        this.items.forEach((e) => {
          if (this.terminals.indexOf(e.req_terminal) == -1)
            this.terminals.push(e.req_terminal);
          if (this.subcompanies.indexOf(e.subcompany) == -1)
            this.subcompanies.push(e.subcompany);
          let d = e.resp_par1;
          let m = "";
          let lines = 0;
          while (d.length > 0) {
            m += "<p>" + d.substring(0, 42) + "</p>";
            d = d.substring(42);
            lines++;
            if (lines == 2) {
              e.nr = d.substr(d.indexOf("Nr.") + 3, 10).trim();
            } else if (lines == 6) {
              if (!this.headers[6].text)
                this.headers[6].text = d
                  .substring(0, 21)
                  .trim()
                  .replaceAll(":", "");
              e.plus = (parseFloat(d.substr(21, 17).trim()) * 100).toFixed();
              if (e.req_par1 == 1) {
                this.allTotal.plus += parseInt(e.plus);
              }
            } else if (lines == 7) {
              if (!this.headers[7].text)
                this.headers[7].text = d
                  .substring(0, 21)
                  .trim()
                  .replaceAll(":", "");
              e.minus = (parseFloat(d.substr(21, 17).trim()) * 100).toFixed();
              if (e.req_par1 == 1) {
                this.allTotal.minus += parseInt(e.minus);
              }
              /* if no last line with count */
              //              e.count = 0;
              //              this.allTotal.count += e.count;
            } else if (lines == 8) {
              if (!this.headers[8].text)
                this.headers[8].text = d
                  .substring(0, 21)
                  .trim()
                  .replaceAll(":", "");
              e.count = parseInt(d.substr(21, 21).trim());
              if (isNaN(e.count)) e.count = 0;
              if (e.req_par1 == 1) {
                this.allTotal.count += e.count;
              }
            }
          }
          e.div = m;
        });
        this.terminals = this.terminals.sort();
        this.subcompanies = this.subcompanies.sort();
        this.lastUpdate = this.$moment();
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-pane {
  width: 100%;
  height: 100%;
}
.progress-container {
  width: 100%;
  text-align: center;
  padding: 20px;
}
.table-fluid {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.filter-pane {
  border-radius: 25px;
}
.dialog-content {
  font-family: monospace;
  white-space: pre;
  font-size: 20px;
}
.detail-row {
  background-color: ghostwhite;
}
</style>